<script setup lang="ts">
import { computed } from "vue";

import { navigationActions } from "@/action/navigationActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { action } from "@/components/action/action";
import { boardKey } from "@/components/board/injectKeys";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { isArtLevelWorkitem, isDependency } from "@/model/stickyType";
import { injectStrict } from "@/utils/vue";

import { isActionVisible } from "../actions";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(
  () =>
    (isArtLevelWorkitem(card) || isDependency(card)) &&
    isActionVisible("breakdown", card, board.value),
);
</script>

<template>
  <IconButton v-if="isVisible" v-bind="action(navigationActions.showBreakdown)" />
</template>
